import React, { useState, useEffect, useRef } from "react";

import FooterNew from "../NavBar/FooterNew";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Document, Page, pdfjs } from "react-pdf";

import attachmenturl from "../../api/attachmenturl";

import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import { Col, Row, Button } from "reactstrap";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

import Nav from "../NavBar/Nav";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import jsPDF from "jspdf";
import moment from "moment";
import { Modal } from "react-bootstrap";
import axios from "axios";
import base_url from "../../api/bootapi";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default function IndivisualVacation() {
  const [backdropopen, setbackdropopen] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [vacationPdfUrl, setVacationPdfUrl] = useState(null);
  const params = useParams();
  const vacationId = params.vacation_id || null;

  const [vacation, setVacation] = useState(null);
  const [isVacationFoundError, setIsVacationFoundError] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);

  const getVacation = () => {
    setbackdropopen(true);
    axios
      .get(`${base_url.api1}/tourapp/vacation?id=${vacationId}`)
      .then((response) => {
        console.log("Vacation details", response.data.vacation);
        setVacation(response.data.vacation);
        setIsVacationFoundError(false);
        setbackdropopen(false);
      })
      .catch((err) => {
        setVacation(null);
        setbackdropopen(false);
        setIsVacationFoundError(true);
      });
  };

  useEffect(() => {
    if (vacationId) {
      getVacation();
    }
  }, [vacationId]);

  useEffect(() => {
    if (vacation) {
      setbackdropopen(true);
      if (!vacation?.tour_details) {
        setbackdropopen(false);
        return;
      }

      const tourFile = vacation.tour_details;
      const fullURL = `${attachmenturl}${tourFile}`;

      const isPdf = /\.pdf$/i.test(tourFile);
      const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(tourFile);
      const isVideo = /\.(mp4|mov|avi|mkv|webm|wmv|flv|mpeg|3gp)$/i.test(
        tourFile
      );
      console.log("Checking ===================> ");
      console.log(isPdf, isImage);

      if (isPdf) {
        setVacationPdfUrl(fullURL);
      } else if (isImage) {
        convertImageToPDF(fullURL).then((blobUrl) => {
          setVacationPdfUrl(blobUrl);
        });
      } else if (isVideo) {
        setVideoUrl(fullURL);
      }

      setbackdropopen(false);
    }
  }, [vacation]);

  // const fullURL = tourpdfurl ? `${attachmenturl}${tourpdfurl}` : null;
  //For Single Page
  // const pdfToImage = async (pdfUrl) => {
  //   const loadingTask = pdfjs.getDocument(pdfUrl);
  //   const pdf = await loadingTask.promise;
  //   const page = await pdf.getPage(1); // Render the first page, or loop if multiple pages are needed

  //   const viewport = page.getViewport({ scale: 1.5 });
  //   const canvas = document.createElement("canvas");
  //   const context = canvas.getContext("2d");
  //   canvas.height = viewport.height;
  //   canvas.width = viewport.width;

  //   const renderContext = {
  //     canvasContext: context,
  //     viewport: viewport,
  //   };
  //   await page.render(renderContext).promise;

  //   // Convert canvas to an image URL
  //   return canvas.toDataURL();
  // };

  // For Multiple Pages

  const pdfToImage = async (pdfUrl) => {
    const loadingTask = pdfjs.getDocument(pdfUrl);
    const pdf = await loadingTask.promise;
    const imageUrls = [];

    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const viewport = page.getViewport({ scale: 1.5 });

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.width = viewport.width;
      canvas.height = viewport.height;

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };

      await page.render(renderContext).promise;

      // Convert canvas to data URL
      const imageUrl = canvas.toDataURL();
      imageUrls.push(imageUrl);
    }

    return imageUrls; // Array of base64 image strings
  };

  const convertImageToPDF = async (imageUrl) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = imageUrl;

    await new Promise((resolve) => (img.onload = resolve));

    const pdf = new jsPDF({
      orientation: img.width > img.height ? "l" : "p",
      unit: "px",
      format: [img.width, img.height],
    });

    pdf.addImage(img, "JPEG", 0, 0, img.width, img.height);
    const blob = pdf.output("blob");
    return URL.createObjectURL(blob); // Blob URL for iframe
  };

  //Old One
  // const printIframe = async (pdfUrl, priceHTML) => {
  //   try {
  //     // Set loading state
  //     setbackdropopen(true);

  //     // Convert the PDF to an image
  //     const imageUrl = await pdfToImage(pdfUrl);

  //     // Create an invisible iframe
  //     const iframe = document.createElement("iframe");
  //     iframe.style.position = "absolute";
  //     iframe.style.width = "0";
  //     iframe.style.height = "0";
  //     iframe.style.border = "none";
  //     document.body.appendChild(iframe);

  //     // Get the iframe's document
  //     const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

  //     // Write the content to the iframe's document
  //     iframeDoc.open();
  //     iframeDoc.write(`
  //       <html>
  //         <head>
  //           <style>
  //             body {
  //               display: flex;
  //               flex-direction: column;
  //               align-items: center;
  //               padding: 20px;
  //             }
  //             img {
  //               width: 100%;
  //               max-height: 1140px;
  //               object-fit: contain;
  //               border: 2px solid black;
  //             }
  //             .price-container {
  //               margin-top: 20px;
  //             }
  //           </style>
  //         </head>
  //         <body>
  //           <img src="${imageUrl}" />

  //         </body>
  //       </html>
  //     `);
  //     iframeDoc.close();
  //     //   <div class="price-container">
  //     //   ${priceHTML}
  //     // </div>
  //     // Wait for the content to be fully loaded and then print
  //     iframe.onload = () => {
  //       setbackdropopen(false);
  //       iframe.contentWindow.focus();
  //       iframe.contentWindow.print();

  //       // Remove the iframe after printing
  //       setTimeout(() => {
  //         document.body.removeChild(iframe);
  //       }, 1000);
  //     };
  //   } catch (error) {
  //     // Handle any errors
  //     setbackdropopen(false);
  //     console.error("Error occurred while printing the iframe:", error);
  //   }
  // };

  // For Single Page Iframe
  // const printIframe = async (pdfUrl) => {
  //   try {
  //     setbackdropopen(true);

  //     // Convert PDF to image
  //     const imageUrl = await pdfToImage(pdfUrl);

  //     // Create hidden iframe
  //     const iframe = document.createElement("iframe");
  //     iframe.style.position = "absolute";
  //     iframe.style.width = "0";
  //     iframe.style.height = "0";
  //     iframe.style.border = "none";
  //     document.body.appendChild(iframe);

  //     const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

  //     // Write only image tag, no extra HTML
  //     iframeDoc.open();
  //     iframeDoc.write(`
  //     <html>
  //       <body style="margin:0;padding:0;">
  //         <img id="printImage" src="${imageUrl}" style="width:100%;max-height:100vh;object-fit:contain;" />
  //       </body>
  //     </html>
  //   `);
  //     iframeDoc.close();

  //     // Wait for image to load before printing
  //     const checkImageLoad = () => {
  //       const img = iframe.contentWindow.document.getElementById("printImage");
  //       if (img && img.complete) {
  //         setbackdropopen(false);
  //         iframe.contentWindow.focus();
  //         iframe.contentWindow.print();
  //         setTimeout(() => {
  //           document.body.removeChild(iframe);
  //         }, 1000);
  //       } else {
  //         setTimeout(checkImageLoad, 100);
  //       }
  //     };

  //     checkImageLoad();
  //   } catch (error) {
  //     setbackdropopen(false);
  //     console.error("Error while printing:", error);
  //   }
  // };

  // For Multiple Page Iframe
  const printIframe = async (pdfUrl) => {
    try {
      setbackdropopen(true);

      // Convert all pages to images (you must return an array of image URLs)
      const imageUrls = await pdfToImage(pdfUrl); // Should return an array: ["page1.png", "page2.png", ...]

      // Create hidden iframe
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

      // Build HTML with multiple <img> tags, one per page
      const imagesHTML = imageUrls
        .map(
          (url, index) =>
            `<img src="${url}" style="width:100%; max-height:100vh; object-fit:contain; margin-bottom:20px;" />`
        )
        .join("");

      iframeDoc.open();
      iframeDoc.write(`
      <html>
        <head>
      <title>Print</title>
      <style>
        html, body {
          margin: 0;
          padding: 0;
        }
        @page {
          size: auto;
          margin: 0;
        }
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        img {
          display: block;
          width: 100vw;
          height: 100vh;
          object-fit: contain;
          page-break-after: always;
          margin: 0;
          padding: 0;
        }
      </style>
    </head>
        <body style="margin:0;padding:0;">${imagesHTML}</body>
      </html>
    `);
      iframeDoc.close();

      // Wait for all images to load before printing
      const waitForImages = () => {
        const imgs = iframe.contentWindow.document.images;
        if (Array.from(imgs).every((img) => img.complete)) {
          setbackdropopen(false);
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 1000);
        } else {
          setTimeout(waitForImages, 100);
        }
      };

      waitForImages();
    } catch (error) {
      setbackdropopen(false);
      console.error("Error while printing:", error);
    }
  };

  const handleDownloadClick = async (file_name) => {
    setbackdropopen(true);
    try {
      const fileUrl = `${attachmenturl}${file_name}`;
      const fileName = file_name?.split("/").pop() || "document.pdf";

      // Fetch the file as a blob
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();

      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setbackdropopen(false);
      }, 100);
    } catch (error) {
      setbackdropopen(false);

      console.error("Download failed:", error);
      // Optionally show error to user
    }
  };

  return (
    <div style={{ backgroundColor: "#F5F6FA" }}>
      <Modal
        show={modalIsOpen}
        onHide={() => setModalIsOpen(false)}
        contentLabel="Example Modal"
        size="xl"
        centered
      >
        <div>
          <img
            src={attachmenturl + vacation?.price_chart}
            alt="Image"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
        <div
          style={{
            height: "8%",
            display: "flex",
            justifyContent: "flex-end",

            gap: "10px",
            padding: "10px 10px",
          }}
        >
          <button
            onClick={() => setModalIsOpen(false)}
            style={{
              fontWeight: "bold",
              borderRadius: "40px",
              padding: "10px 35px",
              color: "#222",
              textAlign: "center",
              outline: "none",
              textDecoration: "none",
              width: "fit-content",
              zIndex: 99999,
              background: "transparent",
            }}
          >
            Close
          </button>
          <button
            onClick={() => handleDownloadClick(vacation?.price_chart)}
            style={{
              fontWeight: "bold",
              borderRadius: "40px",
              padding: "10px 35px",
              color: "#fff",
              textAlign: "center",
              width: "fit-content",

              textDecoration: "none",
              backgroundColor: "#00627e",
            }}
          >
            Download
          </button>
        </div>
      </Modal>
      <React.Fragment>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backdropopen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Nav />
        {vacation ? (
          <div className="container">
            <div
              className="page-head d-flex justify-content-between pb-4 pt-4"
              style={{ marginTop: "1.3rem" }}
            >
              <ul className="breadcrums">
                <Link to="/" className="b-link">
                  Home
                </Link>
                <span className="s_span ">&raquo;</span>
                <Link
                  to={
                    vacation.vacation_type === "Summer"
                      ? "/summer-vacation"
                      : vacation.vacation_type === "Winter"
                        ? "/winter-vacation"
                        : ""
                  }
                  className="b-link"
                >
                  {vacation?.vacation_type} Vacations
                </Link>
                <span className="s_span ">&raquo;</span>
                <Link
                  to="#"
                  state={{ vacation: vacation }}
                  className="b-link active"
                >
                  {vacation.vacation_name}
                </Link>
              </ul>
            </div>

            <div
            // style={{
            //   display: "flex",
            //   alignItems:
            //   gap: "30px",
            // }}
            >
              {/* <div className="indivisual-image-wrapper">
              <img
                src={attachmenturl + vacation.primary_image}
                alt={vacation.vacation_name}
              />
            </div> */}

              <div className="indivisual-details-wrapper">
                <h2>{vacation.vacation_name}</h2>
                <p>{vacation.vacation_description}</p>

                <div className="desination-wrapper">
                  {vacation.destination && (
                    <div>
                      <span>Destination</span>
                      <span>{vacation.destination}</span>
                    </div>
                  )}

                  {vacation.domestic && (
                    <div>
                      <span>Destination Type</span>
                      <span>Domestic USA</span>
                    </div>
                  )}
                  {vacation.international && (
                    <div>
                      <span>Desination Type</span>
                      <span>International</span>
                    </div>
                  )}

                  {vacation.vacation_start_date && (
                    <div>
                      <span>Starts on</span>
                      <span>
                        {moment(
                          vacation.vacation_start_date,
                          "YYYY-MM-DD"
                        ).format("MM/DD/YYYY")}
                      </span>
                    </div>
                  )}

                  {vacation.vacation_start_date && (
                    <div>
                      <span>Ends on</span>
                      <span>
                        {moment(
                          vacation.vacation_end_date,
                          "YYYY-MM-DD"
                        ).format("MM/DD/YYYY")}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                minWidth: "108%",
                marginTop: "50px",
              }}
              className="mobile-view-indivisual-vacation"
            >
              <div style={{ flex: 1 }}>
                {videoUrl ? (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      paddingBottom: "40px",
                    }}
                  >
                    <video
                      controls
                      style={{ width: "100%", height: "100%" }}
                      src={videoUrl}
                    >
                      Your browser does not support the video tag.
                    </video>
                  </div>
                ) : (
                  <Carousel>
                    {vacationPdfUrl == null ? (
                      <img
                        src="No_image_available.png"
                        width="200"
                        height="200"
                        alt="No image available"
                      />
                    ) : (
                      <div>
                        <iframe
                          id="tourpdf"
                          src={vacationPdfUrl}
                          width="100%"
                          height="1140px"
                        />
                        <div className="price-container"></div>
                      </div>
                    )}
                  </Carousel>
                )}
              </div>

              <div
                style={{
                  display: "flex",

                  flexDirection: "column",
                  // alignItems: "flex-start",
                  marginLeft: "20px",
                  gap: "10px",

                  // Adds space between the iframe and buttons
                }}
                className="mobile-indivisual-vacation-buttons"
              >
                {vacationPdfUrl != null && (
                  <button
                    onClick={() => {
                      const priceHTML =
                        document.querySelector(".price-container").outerHTML;
                      printIframe(vacationPdfUrl, priceHTML);
                    }}
                    style={{
                      fontWeight: "bold",
                      borderRadius: "40px",
                      padding: "10px 35px",
                      backgroundColor: "#00627e",
                      //   marginBottom: "10px",
                      outline: "none",
                      textAlign: "center",
                      border: "none",
                      // width: "100%",
                      // Adds space between the buttons
                    }}
                  >
                    Print Brochure
                  </button>
                )}

                {vacation && vacation?.price_chart && (
                  <Button
                    onClick={() => {
                      const tourFile = vacation.price_chart;

                      const isPdf = /\.pdf$/i.test(tourFile);
                      if (isPdf) {
                        window.open(attachmenturl + tourFile, "_blank");
                      } else {
                        setModalIsOpen(true);
                      }
                    }}
                    style={{
                      fontWeight: "bold",
                      borderRadius: "40px",
                      padding: "10px 35px",
                      color: "#fff",
                      textAlign: "center",

                      textDecoration: "none",
                      backgroundColor: "#00627e",

                      //   marginBottom: "10px", // Adds space between the buttons
                    }}
                  >
                    Price Chart
                  </Button>
                )}

                {vacation && vacation.vacation_url && (
                  <Link
                    to={vacation.vacation_url}
                    target="_blank"
                    style={{
                      fontWeight: "bold",
                      borderRadius: "40px",
                      padding: "10px 35px",
                      color: "#fff",
                      textAlign: "center",

                      textDecoration: "none",
                      backgroundColor: "#00627e",

                      //   marginBottom: "10px", // Adds space between the buttons
                    }}
                  >
                    Visit Now
                  </Link>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "50px",
            }}
          >
            {isVacationFoundError ? (
              "No vacation found"
            ) : (
              <>
                <CircularProgress color="inherit" />
                <span>Loading...</span>
              </>
            )}
          </div>
        )}

        <FooterNew />
      </React.Fragment>
    </div>
  );
}
